/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const inventoryMedicineDetails = sqliteTable('inventory_medicine_details', {
  id: text('id').primaryKey().notNull(),
  inventory_item_id: text('inventory_item_id'),
  drug_classification: text('drug_classification'),
  brand_name: text('brand_name'),
  generic_name: text('generic_name'),
  manufacturer: text('manufacturer'),
  indication: text('indication'),
  strength: text('strength'),
  dosage_form: text('dosage_form'),
  route: text('route'),
  precaution_1: text('precaution_1'),
  precaution_2: text('precaution_2'),
  default_instruction: text('default_instruction'),
  default_dosage: text('default_dosage'),
  usage: text('usage'),
  dose: text('dose'),
  dose_unit: text('dose_unit'),
  frequency: text('frequency'),
  duration: text('duration'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
});
